/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Node } from '../../core/models/Node';
import { AaiOperationBase } from './AaiOperationBase';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} opType
 * @class
 * @extends AaiOperationBase
 * @author eric.wittmann@gmail.com
 */
export abstract class AaiOperation extends AaiOperationBase {
    public traits : Array<AaiOperationTrait>;

    public message : AaiMessage;

    public constructor(parent? : any, opType? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof opType === 'string') || opType === null)) {
            let __args = arguments;
            super(parent, opType);
            if(this.traits===undefined) this.traits = null;
            if(this.message===undefined) this.message = null;
            if(this.traits===undefined) this.traits = null;
            if(this.message===undefined) this.message = null;
        } else if(((typeof parent === 'string') || parent === null) && opType === undefined) {
            let __args = arguments;
            let opType : any = __args[0];
            super(opType);
            if(this.traits===undefined) this.traits = null;
            if(this.message===undefined) this.message = null;
            if(this.traits===undefined) this.traits = null;
            if(this.message===undefined) this.message = null;
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && opType === undefined) {
            let __args = arguments;
            super(parent);
            if(this.traits===undefined) this.traits = null;
            if(this.message===undefined) this.message = null;
            if(this.traits===undefined) this.traits = null;
            if(this.message===undefined) this.message = null;
        } else throw new Error('invalid overload');
    }

    /**
     * Adds a tag.
     * @param tag
     * @param {AaiOperationTrait} trait
     */
    public addTrait(trait : AaiOperationTrait) {
        if(this.traits == null) this.traits = <any>([]);
        /* add */(this.traits.push(trait)>0);
    }
}
AaiOperation["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiOperation";
AaiOperation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { AaiMessage } from './AaiMessage';


import { AaiOperationTrait } from './AaiOperationTrait';

